module.exports = __webpack_public_path__ + "media/checkout/billing_rail_products-d4457800.png";